import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of, Subject } from "rxjs";
import { HttpClient } from "@angular/common/http";

import { NuevaFacturaDTO } from "../../models/factura.model";
import { FacturaDTO } from "../../interfaces/factura.interface";
import { PageFacturaDTO } from "../../interfaces/page-factura.interface";

import { environment as ENV } from "environments/environment";
import { FiltrosService } from "../util/filtros.service";

/*
const facturas = [
    
    {
        nroFactura: 123123,
        fecha: new Date(),
        total: 1450000,
        cliente: "Jumbo",
        rut: "12345678-9",
        estado: "Pagada",
        iva: 200000,
        bruto: 1245454,
    },
    {
        nroFactura: 432342,
        fecha: new Date(),
        total: 3231000,
        cliente: "Caja Los Andes",
        rut: "5435433-9",
        estado: "Impaga",
        iva: 600000,
        bruto: 2845454,
    },
];

const oocc = [
    {
        nroOOCC: 444444,
        fecha: new Date(),
        oott: [1, 2, 565464, 503000],
        sucursal: "Jumbo - El belloto",
        monto: 1000000,
        nroFactura: 123467,
    },
    {
        nroOOCC: 555555,
        fecha: new Date(),
        oott: [10094, 88888],
        sucursal: "Caja Los Andes - La Serena",
        monto: 550000,
        nroFactura: 987654,
    },
];
*/

const API = "facturas";

@Injectable({
    providedIn: "root",
})
export class FacturaService {
    
    facturasChanged$: Subject<PageFacturaDTO>;
    facturaChanged$: Subject<FacturaDTO>;
    facturasRefresh$: BehaviorSubject<boolean>;
    
    private paginaActual: number;
    private cantidaResultadosPorPagina: number;
    private totalDeResultados: number;
    private cantidadPaginas: number;
    private orden: string;
    private campoOrden: string;

    constructor(private http: HttpClient, private _filtros: FiltrosService) {
        this.facturasChanged$ = new Subject();
        this.facturaChanged$ = new Subject();
        this.facturasRefresh$ = new BehaviorSubject(null);

        this.resetPaginador();
    }

    fetchFacturas(
                nombre?:string, 
                rut?:string, 
                estado?:number, 
                nroFactura?:number
    ): Observable<PageFacturaDTO> {
        const filtrosFactura = this._filtros.getFiltro("filtrosFacturas");
        
        let parametros:string='';
        parametros+=(filtrosFactura.cliente[0].valor != '')?'&idCliente='+filtrosFactura.cliente[0].valor:'';
        parametros+=(filtrosFactura.estado[0].valor>0)?'&estadoPago='+filtrosFactura.estado[0].valor:'';
        //parametros+=(filtrosFactura.nroOOCC[0].valor != '')?'&numero='+filtrosFactura.nroOOCC[0].valor:'';
        parametros+=(filtrosFactura.rut[0].valor != '')?'&rut='+filtrosFactura.rut[0].valor:'';

        return this.http.get<PageFacturaDTO>(
            `${ENV.apiUrl}${API}?page=${
                this.paginaActual
            }&size=${this.cantidaResultadosPorPagina}${parametros}&sort=${this.campoOrden},${this.orden}`
        );
    }

    fetchDetalleFactura(idFactura: number): Observable<FacturaDTO> {
        return this.http.get<FacturaDTO>(`${ENV.apiUrl}${API}/${idFactura}`)
    }


    registerPago(idFactura:number): Observable<any>{
        return this.http.patch(`${ENV.apiUrl}${API}/${idFactura}/registrarPago`, null)
    }


    unregisterPago(idFactura:number): Observable<any>{
        return this.http.patch(`${ENV.apiUrl}${API}/${idFactura}/anularPago`, null)
    }

    save(factura:NuevaFacturaDTO): Observable<any>{
        return this.http.post<any>(`${ENV.apiUrl}${API}`, factura);
    }

    setCantidadPaginas(cantidadPaginas: number): void {
        this.cantidadPaginas = cantidadPaginas;
    }

    getCantidadPaginas(): number {
        return this.cantidadPaginas;
    }

    getTotalDeResultados(): number {
        return this.totalDeResultados;
    }

    setTotalDeResultados(totalDeResultados: number): void {
        this.totalDeResultados = totalDeResultados;
    }

    setOrden(orden: string): void {
        this.orden = orden;
    }

    setCampoOrden(campoOrden: string) {
        this.campoOrden = campoOrden;
    }

    getOrden(): string {
        return this.orden;
    }

    setPaginaActual(pagina: number): void {
        this.paginaActual = pagina;
    }

    getPaginaActual(): number {
        return this.paginaActual;
    }

    setCantidaResultadosPorPagina(cantidadResultados: number): void {
        this.cantidaResultadosPorPagina = cantidadResultados;
    }

    getCantidaResultadosPorPagina(): number {
        return this.cantidaResultadosPorPagina;
    }

    resetPaginador() {
        this.paginaActual = 0;
        this.cantidaResultadosPorPagina = 10;
        this.totalDeResultados = 0;
        this.cantidadPaginas = 0;
        this.campoOrden="numero"
        this.orden = "asc";
    }


    //Esqueletos - Borrar
    //fetchOOCCFactura(idFactura: number): Observable<any> {
    //    return of(oocc);
    //}

    //fetchOOCC(): Observable<any> {
    //    return of(oocc);
    //}
}
